var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PersonalData',{attrs:{"title":"About Me"}}),_c('LanguageSkills',{attrs:{"title":"Language Skills"}}),_c('Timeline',{attrs:{"title":"Timeline"}}),_c('ITSkills',{attrs:{"title":"IT-Skills"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }